import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import React, { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { UpdateVersionContent } from './UpdateVersionContent'

interface IProps {
  selectedVersion: IELTData
  closeDialog: () => void
  show: boolean
}

export const UpdateVersionDialog = ({ selectedVersion, closeDialog, show }: IProps) => {
  const contentProps = useMemo(
    () => ({
      selectedVersion,
      closeDialog,
    }),
    [closeDialog, selectedVersion]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={UpdateVersionContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}
